import { Component, EventEmitter, Injector, Input, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MatDialog } from '@angular/material';
import { ActivatedRoute } from '@angular/router';
import { DataStateChangeEvent, GridComponent } from '@progress/kendo-angular-grid';
import * as _ from 'lodash';
import { ToastrService } from 'ngx-toastr';
import { finalize } from 'rxjs/operators';
import { CommonService } from 'src/app-core/services/common.service';
import { AppComponentBase } from 'src/app/shared/app-component-base';
import { ConfirmDialogComponent } from '../../shared/confirm-dialog/confirm-dialog.component';
import { CommonDataModel } from '../common-data-model';
import { OrdersFreightShopperFormComponent } from '../orders-freight-shopper-form/orders-freight-shopper-form.component';
import { CommonConstants } from 'src/app-core/constants/common-constants';

@Component({
    selector: 'app-orders-freight-shopper-list',
    templateUrl: './orders-freight-shopper-list.component.html',
    styleUrls: ['./orders-freight-shopper-list.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class OrdersFreightShopperListComponent extends AppComponentBase implements OnInit {
    @ViewChild('grid', { static: true }) private grid: GridComponent;
    @ViewChild('freightShopperForm', { static: true }) freightShopperForm: NgForm;
    @Output() emitFreightSopperDetails: EventEmitter<any> = new EventEmitter<any>();
    @Output() emitSelectedAccessorials: EventEmitter<any> = new EventEmitter<any>();
    @Input() shippingInfo: any;
    @Input() isFinalBol: any;
    @Input() containers: any;
    @Input() readOnly: boolean;
    @Input() set callFrom(callFrom: any) {
        if (callFrom) {
            this.sourceOfCall = callFrom;
        }
    }
    @Input() set finalDimsRoutingDataForRates(finalDimsRoutingDataForRates: any) {
        if (finalDimsRoutingDataForRates && finalDimsRoutingDataForRates.carrierId) {
            this.getQuoteRequest.carriers = [
                {
                    id: finalDimsRoutingDataForRates.carrierId,
                    carrierName: finalDimsRoutingDataForRates.carrierName
                }
            ];
        }
    }
    @Input() set carrierCostData(carrierCostData: any) {
        if (carrierCostData) {
            this.carrierCostList = carrierCostData;
        }
    }

    carrierCostList: any;
    commonDataModel = new CommonDataModel();
    classList = this.commonDataModel.geCarrierClass();
    getQuoteRequest = this.commonDataModel.getQuoteRequestModel;
    isFreightShopperAdded = false;
    frightShopperRateData: any = {
        items: [],
        totalResults: 1
    };
    freightShopperListPageSize = 5;
    isFormLoading = false;
    sourceOfCall: any;
    selectedFreightShopperIndexId = null;
    updatedCarrierCostFromFSForm = [];
    orderId: string;


    constructor(
        injector: Injector,
        public dialog: MatDialog,
        private activatedRoute: ActivatedRoute,
        private toastr: ToastrService,
        private commonService: CommonService) {
        super(injector);
    }

    ngOnInit() {
        if (this.activatedRoute.snapshot.queryParams.jobId) {
            this.orderId = this.activatedRoute.snapshot.queryParams.jobId;
        } else if (this.activatedRoute.snapshot.queryParams.quoteId) {
            this.orderId = this.activatedRoute.snapshot.queryParams.quoteId;
        }
        this.onRefreshGridData();
    }


    // start onFreightShopperOpenDialog
    onFreightShopperOpenDialog(): void {
        if (this.orderId) {
            switch (this.sourceOfCall) {
                case 'overviewCarriesCosts':
                    if (!this.shippingInfo.shippingFrom || !this.shippingInfo.shippingFrom.contactId || !this.shippingInfo.shippingTo || !this.shippingInfo.shippingTo.contactId) {
                        this.toastr.warning('Shipping Information Details Required');
                        return;
                    }
                    if (this.containers.filter(lineitem => lineitem.lineItems.find(item => !item.itemName)).length > 0) {
                        this.toastr.warning('Please select shipping container item name');
                        return;
                    }
                    if (this.containers.filter(lineitem => lineitem.lineItems.find(item => !item.length || !item.width || !item.height || !item.weight)).length > 0) {
                        this.toastr.warning(CommonConstants.appComponent.itemDimenionsToasterMessage);
                        return;
                    }
                    const lineItems: any = [];
                    this.containers.map((item) => item.lineItems)
                        .forEach(item => {
                            item.map((lineItem) => lineItem.nmfcClass = '85');
                            lineItems.push.apply(lineItems, item);
                        });
                    this.getQuoteRequest.items = lineItems;
                    this.dialogOrdersFreightShopperForm();
                    break;
                case 'finalDimsRoutig':
                    let totalWeight = 0;
                    this.carrierCostList = {
                        data: [],
                        total: 0
                    };
                    this.containers.map((item) => {
                        this.carrierCostList.data.push(
                            {
                                quantity: item.quantity,
                                outerLength: item.length,
                                outerWidth: item.width,
                                outerHeight: item.height,
                                unitWeight: item.unitDimentionWeight,
                                class: item.freightClass,
                                packageType: item.packageType,
                                unitDimentionWeight: item.unitDimentionWeight,
                                containerName: item.containerName,
                                extWeight: item.weight,
                                description: item.description,
                                isFinalDims: true,
                                itemContainerId: item.itemContainerId,
                                nmfc: item.nmfc
                            }
                        );
                        totalWeight += item.weight;
                    });
                    this.carrierCostList.total = totalWeight;
                    if (this.carrierCostList.data.some(item => 
                        ['outerLength', 'outerWidth', 'outerHeight', 'extWeight', 'unitWeight', 'unitDimentionWeight']
                        .some(field => !item[field] || item[field] === 0)
                    )) {
                        this.toastr.warning(CommonConstants.appComponent.itemDimenionsToasterMessage);
                        return;
                    }
                    this.dialogOrdersFreightShopperForm();
                    break;
                default:
                    if (!this.isFinalBol) {
                        this.dialogOrdersFreightShopperForm();
                    } else {
                        this.setGetQuote();
                    }
                    break;
            }
        } else {
            this.toastr.error('Please save order to get quote from carriers.', 'Error!');
        }
    }

    dialogOrdersFreightShopperForm() {
        this.dialog.open(OrdersFreightShopperFormComponent, {
            position: {
                right: '0',
            },
            panelClass: ['center_layout', 'full_min_height'],
            hasBackdrop: false,
            data: {
                contactId: null,
                isEdit: false,
                accountId: 1111,
                accountName: 'account name',
                carrierCostList: _.cloneDeep(this.carrierCostList),
                orderId: this.orderId,
                isShipperAddress: this.shippingInfo.shippingFrom.isShipperAddress,
                isConsigneeAddress: this.shippingInfo.intermediary ? this.shippingInfo.intermediary.isConsigneeAddress : this.shippingInfo.shippingTo.isConsigneeAddress
            },
            autoFocus: false
        }).afterClosed()
            .subscribe((response: any) => {
                if (response && response.confirmResult === true) {
                    this.updatedCarrierCostFromFSForm = response.updatedCarrierCostList.data;
                    this.getQuoteRequest.carriers = response.selectedCarries.map(item => {
                        return {
                            id: item.id,
                            carrierName: item.carrierName
                        };
                    });
                    this.getQuoteRequest.accessorials = response.selectedAccessorials;
                    this.setGetQuote();
                }
                if (response && response.from === 'ratesGrid') {
                    this.emitFreightSopperDetails.emit(response.data);
                    this.emitSelectedAccessorials.emit(response.accessorials);
                }
            });
    }

    // end onFreightShopperOpenDialog

    // start getQuoteByData
    setGetQuote() {
        if (this.shippingInfo.shippingFrom.isShipperAddress) {
            this.getQuoteRequest.shipper.city = this.shippingInfo.shippingFrom.city;
            this.getQuoteRequest.shipper.state = this.shippingInfo.shippingFrom.provinceName;
            this.getQuoteRequest.shipper.zipcode = this.shippingInfo.shippingFrom.zipCode;
        } else if (this.shippingInfo.shippingFrom) {
            this.getQuoteRequest.shipper.city = this.commonService.getTCity();
            this.getQuoteRequest.shipper.state = this.commonService.getTState();
            this.getQuoteRequest.shipper.zipcode = this.commonService.getTZipcode();
        }
        if (this.shippingInfo.shippingTo) {
            this.getQuoteRequest.consignee.city = this.shippingInfo.shippingTo.city;
            this.getQuoteRequest.consignee.state = this.shippingInfo.shippingTo.provinceName;
            this.getQuoteRequest.consignee.zipcode = this.shippingInfo.shippingTo.zipCode;
        }
        if (this.sourceOfCall === 'overviewCarriesCosts') {
            let totalWeight = 0;
            this.getQuoteRequest.items = [];
            this.updatedCarrierCostFromFSForm.map(item => {
                this.getQuoteRequest.items.push(
                    {
                        quantity: item.quantity,
                        length: Math.ceil(item.outerLength),
                        width: Math.ceil(item.outerWidth),
                        height: Math.ceil(item.outerHeight),
                        weight: Math.ceil(item.unitWeight),
                        nmfcClass: this.classList.find(c => c.label === item.class).label,
                        description: ''
                    }
                );
                totalWeight += item.extWeight;
            });
            this.getQuoteRequest.totalWeight = Math.ceil(totalWeight);
        } else {
            this.getQuoteRequest.totalWeight = this.containers.map(item => item.quantity * item.weight).reduce((a, b) => a + b, 0);
            this.getQuoteRequest.items = _.cloneDeep(this.containers);
            this.getQuoteRequest.items.map(item => {
                item.nmfcClass = item.freightClass;
                item.length = Math.ceil(item.length);
                item.width = Math.ceil(item.width);
                item.height = Math.ceil(item.height);
                item.weight = Math.ceil(item.weight);
            });
        }
        this.getQuoteRequest.itemCount = this.getQuoteRequest.items.length;
        this.getQuoteRequest.serviceClass = 'STD';
        this.getQuoteRequest.pickupDate = this.commonService.setTodayDate();
        this.getQuoteRequest.deliveryDate = this.commonService.setTomorrowDate();
        this.getQuoteByData();
    }
    // end getQuoteByData

    // start getQuoteByData
    getQuoteByData() {
        this.isFormLoading = true;
        this.commonService.getFreightShopperRates(this.getQuoteRequest)
            .pipe(finalize(() => (this.isFormLoading = false)))
            .subscribe((response: any) => {
                this.isFormLoading = false;
                if (response.isSuccess) {
                    this.isFreightShopperAdded = true;
                    const carrierList = [];
                    if (response.data.carrierRates && response.data.carrierRates.length > 0) {
                        response.data.carrierRates.forEach((item, index) => {
                            item.freightShopperIndexId = ++index;
                            if (item.carrierMessage && item.carrierMessage.length > 0) {
                                item.carrierMessage.forEach(element => {
                                    this.toastr.warning(element.message);
                                });
                            } else {
                                carrierList.push(item);
                            }
                        });
                    }
                    this.frightShopperRateData.items = carrierList;
                    this.frightShopperRateData.totalResults = carrierList.length;
                    this.onRefreshGridData();
                } else {
                    this.frightShopperRateData = {
                        items: [],
                        totalResults: 0
                    };
                    this.toastr.error(response.errors || 'Something Went wrong, Please Re-try.', 'Error!');
                }
            });
    }
    // end getQuoteByData

    // start onRefreshGridData
    onRefreshGridData(): void {
        this.grid.dataStateChange.emit({
            skip: 0,
            take: this.kendogridHelper.defaultRecordsCountPerPage,
            filter: undefined,
            group: undefined,
            sort: this.kendogridHelper.sort,
        });
    }
    // end onRefreshGridData

    // start getGridRecords
    getGridRecords(event: DataStateChangeEvent): void {
        if (event) {
            this.kendogridHelper.dataStateChangeEvent(event);
        }
        this.kendogridHelper.showLoadingIndicator();
        this.kendogridHelper.setGridData(this.frightShopperRateData);
        this.kendogridHelper.hideLoadingIndicator();
    }
    // end getGridRecords

    // start onFreightShopperClear
    onFreightShopperClear() {
        this.freightShopperOpenConfirmDialog();
    }
    // end onFreightShopperClear

    // start freightShopperDetailsReset
    freightShopperDetailsReset() {
        this.emitFreightSopperDetails.emit({ isReset: true });
        this.frightShopperRateData.items = [];
        this.isFreightShopperAdded = false;
        this.onRefreshGridData();
    }
    // end freightShopperDetailsReset

    // start freightShopperOpenConfirmDialog
    freightShopperOpenConfirmDialog(): void {
        const dialogRef = this.dialog.open(ConfirmDialogComponent, {
            panelClass: 'confirm_layout',
            hasBackdrop: false,
            data: {
                message: 'Are you sure to clear freight shopper details!',
                isShowTitle: true
            }
        }).afterClosed()
            .subscribe((response: { confirmResult: boolean }) => {
                if (response && response.confirmResult === true) {
                    this.freightShopperDetailsReset();
                }
            });
    }
    // end freightShopperOpenConfirmDialog

    // start selectFreightShopper
    selectFreightShopper = (data: any) => {
        this.freightShopperForm.form.markAsDirty();
        this.emitFreightSopperDetails.emit(data);
    }
    // end selectFreightShopper
}
